var _style, _path, _path2, _path3, _path4, _path5, _defs, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTurtleSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1082.4 725.9",
    style: {
      enableBackground: "new 0 0 1082.4 725.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00E379;}\n\t.st1{clip-path:url(#SVGID_00000034053539514396143110000016565104961851359412_);}\n\t.st2{fill:#008849;}\n\t.st3{fill:#BEFFDA;stroke:#008849;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#002600;}\n\t.st6{fill:none;stroke:#008849;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000073684388850334302290000013603497017571766180_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_layer"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M963.1,237.7c3.3-16.3,30-13,49-39.6c14-19.5,11.8-38.2,15.8-38c5.7,0.3,13.2,36.8,3.2,72.8 c-4.5,16.3-11.5,41.5-28.5,44.3C983.7,280.5,959.7,254.5,963.1,237.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M773.8,399.5c21.9,41,22.8,71.6,19.4,92.2c-5.5,33.9,29.8,54.5,38.6,84.5c7,23.7-29,32.5-32.3,37.4 c-4.9,7.2-52.5-3.8-85.5-38c-23-23.9-21.9-41.5-57.7-105.5c-9.8-17.5-18.4-31.5-24-40.3L773.8,399.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M864.1,433.9c20.6,41.6,45,60.2,63.7,69.5c30.7,15.2,27,55.9,46.2,80.6c15.2,19.5,43.4-4.7,49.2-4.5 c8.7,0.2,27.5-44.9,18.8-91.6c-6-32.6-21-42-52.2-108.3c-8.5-18.2-14.9-33.3-18.8-43L864.1,433.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.9,513.2c-8.5,45.6-0.2,75.2,9.2,93.8c15.4,30.7,39.8,44,40.3,75.2c0.4,24.7-14.3,39.2-9.7,42.9 c6.8,5.4,49-19.4,70.1-61.9c14.8-29.7,8.5-46.2,23.3-118c4.1-19.7,8.1-35.6,10.8-45.7L410.9,513.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.3,435.2c-21.9,41-22.8,71.6-19.4,92.2c5.5,33.9,24.7,53.9,15.8,83.9c-7,23.7-25.4,33.1-22.1,38 c4.9,7.2,52.5-3.8,85.5-38c23-23.9,21.9-41.5,57.7-105.5c9.8-17.5,18.4-31.5,24-40.3L290.3,435.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M331.4,213.7c34.4-46.9,56.5-77.2,96.7-103.2c87.1-56.3,207-59.1,296.9-21.1 c72.9,30.8,69.3,64.5,182.7,119.4c68.1,33,91.1,31.3,98.4,52.7c21,61.4-128.3,192.5-288.1,245.9 c-124.6,41.7-118.8-9.5-347.8,28.1c-30.4,5-79.6,14-108.1-13.7c-29.2-28.3-21.3-80-14.9-121.6 C249.7,384,262.6,307.5,331.4,213.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000112603421020175033870000015771205362916001156_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000112603421020175033870000015771205362916001156_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.1,199.3c40.7-55.7,67-91.5,114.7-122.4c103.3-66.7,245.5-70,352-25c86.4,36.6,82.2,76.5,216.6,141.6 c80.8,39.1,108,37.2,116.6,62.5c24.9,72.8-152.1,228.2-341.6,291.6C590.8,597.1,597.6,536.4,326,581 c-36,5.9-94.3,16.6-128.1-16.2c-34.6-33.6-25.2-94.9-17.6-144.1C183.2,401.2,198.6,310.6,280.1,199.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M239.9,168.7l74.4-70.5c15.7-14.9,38.2-20.3,58.9-14.1l98.2,29.2c20.8,6.2,36.6,22.9,41.7,44l23.8,99.6 c5,21-1.6,43.1-17.2,58l-74.4,70.5c-15.7,14.9-38.2,20.3-58.9,14.1l-98.2-29.2c-20.8-6.2-36.6-22.9-41.7-44l-23.8-99.6 C217.6,205.6,224.2,183.5,239.9,168.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.9,89.6l74.4-70.5C642,4.2,664.4-1.1,685.2,5l98.2,29.2c20.8,6.2,36.6,22.9,41.7,44l23.8,99.6 c5,21-1.5,43.2-17.2,58.1l-74.4,70.5c-15.7,14.9-38.2,20.3-58.9,14.1l-98.2-29.2c-20.7-6.2-36.6-22.9-41.7-44l-23.8-99.7 C529.6,126.6,536.2,104.4,551.9,89.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M774.2,321l74.4-70.5c15.7-14.9,38.2-20.3,58.9-14.1l98.2,29.2c20.8,6.2,36.6,22.9,41.7,44l23.8,99.6 c5,21-1.5,43.2-17.2,58l-74.4,70.5c-15.7,14.9-38.2,20.3-58.9,14.1l-98.2-29.2c-20.7-6.2-36.6-22.9-41.7-44l-23.8-99.6 C751.9,358,758.5,335.9,774.2,321z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M470.6,403.3l74.4-70.5c15.7-14.9,38.2-20.3,58.9-14.1l98.2,29.2c20.7,6.2,36.6,22.9,41.7,44l23.8,99.6 c5,21-1.5,43.2-17.2,58L676,620c-15.7,14.9-38.2,20.3-58.9,14.1l-98.2-29.2c-20.8-6.2-36.6-22.9-41.6-44l-23.9-99.6 C448.4,440.3,454.9,418.1,470.6,403.3z"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.4,390.9c1.4,72.9-96.1,132-214.7,132S0,463.8,0,390.9c0-21.8,8.6-42.3,23.7-60.4c-1.2-3-1.8-6.2-1.8-9.4 c0-2.5,0.1-18.8,0.3-21.2C28,233.8,111.9,170,214.5,170S401.3,234,406.9,300.2c0.2,2.3,0.3,18.6,0.3,21c0,2.8-0.5,5.6-1.4,8.3 C420.5,345.5,428.9,365.7,429.4,390.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M154.3,262.4c0.1,20.4-16.5,37-36.9,37.1c-20.4,0.1-37-16.5-37.1-36.9c-0.1-20.4,16.5-37,36.9-37.1 c19.7-0.1,36,15.4,37,35.1l0,0C154.3,261.2,154.3,261.8,154.3,262.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M154.3,262.4c0,20.4-16.5,36.9-36.9,36.9c-12.9,0-24.9-6.8-31.6-17.8c0-0.6,0-1.2,0-1.8 c0-20.4,16.6-36.9,37-36.9c12.9,0,24.9,6.7,31.6,17.8l0,0C154.3,261.2,154.3,261.8,154.3,262.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352.1,265.1c-0.3,20.4-17.1,36.7-37.5,36.3c-19.9-0.3-36-16.4-36.3-36.3c0-1.1,0-2.2,0.1-3.4 c1.9-20.3,19.9-35.2,40.2-33.3C337.6,230.2,352.1,246.1,352.1,265.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M347.9,279.4c0,1.1,0,2.2-0.1,3.4c-9.7,17.9-32.1,24.6-50.1,14.9c-11.9-6.4-19.4-18.9-19.4-32.5 c0-1.1,0-2.2,0.1-3.4c9.7-17.9,32.1-24.6,50.1-14.9C340.4,253.3,347.9,265.8,347.9,279.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.8,347.9c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2S185.8,345.6,185.8,347.9 L185.8,347.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 252.4,
    cy: 349.3,
    r: 4.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M153.7,339.2c10.6-9,23-15.8,36.4-19.8c8.9-2.7,29.1-8.4,53-0.8c15.5,5,29.2,14.3,39.6,26.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M119.7,393.2c7.1,5.6,22.2,16.1,46.2,23.3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.2,415.5c15-3.8,29.5-9.5,43.1-17"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.5,410.4c-6.5,11-18.3,27.7-35.4,38c-8.9,5.3-28.9,16.8-53.2,3.9c-18.4-9.7-31-29-37.9-41.9 c5.5,2.1,11.1,4,16.8,5.5c42.8,11.5,79,2.9,95-1.2C272.9,413.4,277.9,412,282.5,410.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.4,413c-1.2,1.1-2.6,2.1-4,2.9c-6.2,3.6-12.5,3.4-14.8,3.4c-5.3,0.1-12.3,2.1-22.8,10.5 c-4.1-3.5-8.7-6.3-13.7-8.4c-3.1-1.3-6.4-2-9.8-2.1c-2.3,0-8.6,0.2-14.8-3.4c-1.4-0.8-2.8-1.8-4-2.9L259.4,413z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtleSvg);
export default __webpack_public_path__ + "static/media/TurtleSVG.b6729b9558ed257db012e1ee87f4827e.svg";
export { ForwardRef as ReactComponent };